import React from 'react'
import { useRouteMatch, Redirect, Switch, Route } from 'react-router-dom'
import * as Views from './views'
import Layout from './Layout'
import RouterOutlet from '../../components/RouterOutlet'

const propTypes = {}
const defaultProps = {}

function Routes() {
  const { path } = useRouteMatch()

  const routes = [
    {
      url: `${path}/dashboard`,
      component: Views.Dashboard,
    },
    {
      url: `${path}/orders/:id`,
      component: Views.OrderShow,
      layoutParams: { showBackToSearch: true },
    },
  ]

  return (
    <Switch>
      <Redirect exact from={path} to={`${path}/dashboard`} />
      <Route path={path}>
        <RouterOutlet routes={routes} Layout={Layout} />
      </Route>
    </Switch>
  )
}

Routes.propTypes = propTypes
Routes.defaultProps = defaultProps

export default Routes
